import React, { useState, useEffect } from 'react'
import AdminLayout from '../AdminLayout';
import ContentHeader from '../layout/ContentHeader'
import { GET_QUOTE_NUMBER, SAVE_QUOTE } from '../../../data/url';
import httpClient from '../../../http/HttpRequest';
import { useNavigate } from 'react-router-dom';
import Alert from '../../../feature/Alert';
import { useTranslation } from 'react-i18next';
import Helper from '../../../helper/Helper';
import SelectCustomer from '../layout/SelectCustomer';
import ProductCal from '../layout/ProductCal';

export default function NewQuote() {

  const [state_id, setStateId] = useState('');
  const [customerId, setCustomerId] = useState('');
  const [customer, setCustomer] = useState({});
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [quoteDetails, setQuoteDetails] = useState({ prefix: '', number: '', date: Helper.getToday(), due_date: '' });

  useEffect(() => {
    getInvoiceNumber();
  }, [])

  const getInvoiceNumber = async (e) => {
    const res = await httpClient.post(GET_QUOTE_NUMBER, {});
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        setQuoteDetails(prevquoteDetails => ({
          ...prevquoteDetails,
          prefix: result.prefix || '',
          number: result.number || ''
        }));
      }
    }
  }
  const handelSubmit = (products, commanData, totals, txnType, payment) => {
    if (validateField()) {
      if (products.length > 0) {
        let p = quoteDetails;
        p['customer_id'] = customerId;
        p['state'] = state_id;
        p['products'] = products;
        p['totals'] = totals;
        p['commonData'] = commanData;
        p['txnType'] = txnType;
        saveOrder(p);
      } else {
        Alert.error('Products are empty');
      }

    }
  }

  const saveOrder = async (post) => {
    const res = await httpClient.post(SAVE_QUOTE, post);
    if (res.requestStatus === "OK") {
      const result = res.result;
      if (result.status === 1) {
        Alert.success(result.message);
        navigate('/root/quotes');
      } else {
        Alert.failure(result.message);
      }
    }
  }

  const validateField = () => {
    let formErrors = {};
    let valid = true;
    if (customerId === '') {
      Alert.error('Select Customer');
      valid = false;
    }
    setErrors(formErrors);
    return valid;
  }

  const handleInputChange = (fieldName, event) => {
    const value = event.target.value;
    const order = { ...quoteDetails };
    order[fieldName] = value;
    setQuoteDetails(order);
  };

  const remitCustomer = (data) => {
    setCustomerId(data.customer_id);
    setStateId(data.state_id);
    setCustomer(data.customer);
  }

  return (
    <AdminLayout>
      <div className="content-wrapper">
        <ContentHeader
          title="new_quote" subTitle="quotes" subTitleLink="root/quotes"
        />
        <div className="col-lg-12 grid-margin stretch-card">
          <div className='card'>
            <div className='card-body'>
              <div>
                <SelectCustomer remitCustomer={remitCustomer} />
              </div>
              <div className='row mt-2'>
                <div className='col-md-4 '>
                  <label>{t('number')}</label>
                  <div className='input-group'>
                    <div className="input-group-prepend mr-1" style={{ width: "80px" }}>
                      <input id='prefix' value={quoteDetails.prefix || ''} type='text' name='prefix' className='form-control form-control-sm' onChange={(e) => handleInputChange('prefix', e)} />
                    </div>
                    <input id='number' value={quoteDetails.number || ''} type='text' name='number' className='form-control form-control-sm' onChange={(e) => handleInputChange('number', e)} />
                  </div>
                </div>
                <div className='col-md-3'>
                  <label>{t('date')}</label>
                  <input id='date' value={quoteDetails.date} type='date' name='date' className='form-control form-control-sm' onChange={(e) => handleInputChange('date', e)} />
                </div>
                <div className='col-md-3'>
                  <label>{t('due_date')}</label>
                  <input id='due_date' value={quoteDetails.due_date} type='date' name='due_date' className='form-control form-control-sm' onChange={(e) => handleInputChange('due_date', e)} />
                </div>
              </div>
              <ProductCal title="quote" onSubmit={handelSubmit} customer={customer} />
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  )
}
